import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = { class: "row col-md-7" }
const _hoisted_3 = { class: "el-input-group" }
const _hoisted_4 = { class: "col-md-9" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "row col-md-7" }
const _hoisted_7 = { class: "el-input-group" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "row col-md-7" }
const _hoisted_11 = { class: "el-input-group" }
const _hoisted_12 = { class: "row col-md-7" }
const _hoisted_13 = { class: "el-input-group" }
const _hoisted_14 = { class: "row col-md-7" }
const _hoisted_15 = { class: "el-input-group" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "col-md-7" }
const _hoisted_19 = { class: "el-input-group" }
const _hoisted_20 = {
  key: 0,
  class: "me-3"
}
const _hoisted_21 = {
  key: 0,
  class: "modal"
}
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = ["disable"]
const _hoisted_28 = { class: "page-content-info d-flex align-items-center justify-content-between" }
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_31 = { class: "btn btn-outline-light" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DeleteReasonDialog = _resolveComponent("DeleteReasonDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[36] || (_cache[36] = _createElementVNode("h2", null, "Авансирование/удержание", -1)),
    _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[24] || (_cache[24] = _createElementVNode("label", {
            for: "accountingMonth",
            class: "form-label col-md-3"
          }, "Расчетный месяц", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "1",
                max: "12",
                step: "1",
                class: "form-control",
                id: "accountingMonth",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchParam.accountingMonth) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParam.accountingMonth]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[25] || (_cache[25] = _createElementVNode("label", {
            for: "accountingYear",
            class: "form-label col-md-3"
          }, "Расчетный год", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "2024",
                step: "1",
                class: "form-control",
                id: "accountingYear",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParam.accountingYear) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParam.accountingYear]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[26] || (_cache[26] = _createElementVNode("label", {
            for: "binList",
            class: "form-label col-md-3"
          }, "Список бинов:", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "binList",
            cols: "15",
            rows: "5",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchParam.binList) = $event)),
            required: "",
            placeholder: "1234567, 1234567, ...\nили\n1234567\n1234567\n..."
          }, null, 512), [
            [_vModelText, _ctx.searchParam.binList]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[27] || (_cache[27] = _createElementVNode("label", {
            for: "binList",
            class: "form-label col-md-3"
          }, "Список LMS ID:", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "binList",
            cols: "15",
            rows: "5",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchParam.lmsIdList) = $event)),
            required: "",
            placeholder: "1-1-1, 1-1-2, ...\nили\n1-1-1\n1-1-2\n..."
          }, null, 512), [
            [_vModelText, _ctx.searchParam.lmsIdList]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[28] || (_cache[28] = _createElementVNode("label", {
            for: "katoCode",
            class: "form-label col-md-3"
          }, "Населенный пункт", -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_multiselect, {
                modelValue: _ctx.kato,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.kato) = $event)),
                options: _ctx.katoList,
                searchable: true,
                closeOnSelect: true,
                "track-by": "code",
                "custom-label": _ctx.formattedKatoLabel,
                placeholder: "Выберите Като",
                multiple: false,
                "clear-on-select": true
              }, null, 8, ["modelValue", "options", "custom-label"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          (_ctx.hasAccess(_ctx.adminWriteRoles))
            ? (_openBlock(), _createElementBlock("label", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchParam.includeDeleted) = $event)),
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fetchSearch(true)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.searchParam.includeDeleted]
                ]),
                _cache[29] || (_cache[29] = _createTextVNode(" Показать удалённые "))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fetchSearch(true)))
          }, "Поиск"),
          _createElementVNode("button", {
            class: "btn btn-warning",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearSearchParam()))
          }, "Сбросить фильтр")
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "open-modal-btn float-end",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showUploadModal = true))
    }, "Загрузить Авансирование/удержание"),
    (_ctx.showUploadModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _cache[33] || (_cache[33] = _createElementVNode("h4", null, "Выберите .xlsx файл для загрузки Авансирование/удержание", -1)),
            _createElementVNode("form", {
              onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleUploadSubmit && _ctx.handleUploadSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_23, [
                _cache[30] || (_cache[30] = _createElementVNode("label", {
                  for: "accountingMonth",
                  class: "form-label"
                }, "Расчетный месяц", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  min: "1",
                  max: "12",
                  step: "1",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.accountingMonth) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.accountingMonth]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[31] || (_cache[31] = _createElementVNode("label", {
                  for: "accountingYear",
                  class: "form-label"
                }, "Расчетный год", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  min: "2023",
                  step: "1",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.accountingYear) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.accountingYear]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[32] || (_cache[32] = _createElementVNode("label", {
                  for: "timesheetFile",
                  class: "form-label"
                }, [
                  _createTextVNode(" Выберите .xlsx файл "),
                  _createElementVNode("br"),
                  _createElementVNode("a", { href: "/templates/kindergarten_retentions.xlsx" }, "Чтобы скачать шаблон excel - нажмите по этой строке")
                ], -1)),
                _createElementVNode("input", {
                  type: "file",
                  id: "timesheetFile",
                  class: "form-control",
                  required: "",
                  accept: ".xlsx",
                  onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                }, null, 32)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "submit-btn",
                  disable: _ctx.isLoading
                }, _toDisplayString(_ctx.isLoading ? 'Загружается...' : 'Загрузить'), 9, _hoisted_27)
              ])
            ], 32),
            _createElementVNode("button", {
              class: "close-modal-btn",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showUploadModal = false))
            }, "Закрыть")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_b_pagination, {
      modelValue: _ctx.currentPage,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.currentPage) = $event)),
      "total-rows": _ctx.pageResponse?.totalElements,
      "per-page": _ctx.searchParam.perPage
    }, null, 8, ["modelValue", "total-rows", "per-page"]),
    (_ctx.hasAccess(_ctx.adminRoles) && _ctx.selectedLive.length > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.openDeletionConfirmationModal && _ctx.openDeletionConfirmationModal(...args))),
          type: "button",
          class: "btn btn-danger"
        }, "Удалить"))
      : _createCommentVNode("", true),
    (_ctx.hasAccess(_ctx.adminWriteRoles) && _ctx.selectedDeleted.length > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showRestoreModal = true)),
          type: "button",
          class: "btn btn-success ms-2"
        }, "Восстановить"))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", null, [
        _cache[34] || (_cache[34] = _createTextVNode("Найдено: ")),
        _createElementVNode("span", null, _toDisplayString(_ctx.totalCount), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _cache[35] || (_cache[35] = _createElementVNode("span", null, "Элементов в странице: ", -1)),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-secondary", {'active': _ctx.searchParam.perPage == 10}]),
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.fetchSearch(false)))
        }, "10", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-secondary", {'active': _ctx.searchParam.perPage == 50}]),
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.fetchSearch(false)))
        }, "50", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-secondary", {'active': _ctx.searchParam.perPage == 100}]),
          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.fetchSearch(false)))
        }, "100", 2)
      ])
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.items,
      style: {"width":"100%"},
      "row-class-name": _ctx.rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          label: "#",
          width: "50"
        }, _createSlots({ _: 2 }, [
          (_ctx.hasAccess(_ctx.adminRoles))
            ? {
                name: "default",
                fn: _withCtx((scope) => [
                  _createElementVNode("label", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: scope.row.id,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedKindergartenRetention) = $event))
                    }, null, 8, _hoisted_32), [
                      [_vModelCheckbox, _ctx.selectedKindergartenRetention]
                    ])
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1024),
        _createVNode(_component_el_table_column, {
          label: "БИН",
          prop: "bin"
        }),
        _createVNode(_component_el_table_column, {
          label: "LMS ID",
          prop: "lmsId"
        }),
        _createVNode(_component_el_table_column, {
          label: "Расчетный месяц",
          prop: "accountingMonth"
        }),
        _createVNode(_component_el_table_column, {
          label: "Расчетный год",
          prop: "accountingYear"
        }),
        _createVNode(_component_el_table_column, {
          label: "Авансирование/удержание",
          prop: "price"
        }),
        (_ctx.searchParam.includeDeleted)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "Удалено"
            }, {
              default: _withCtx((scope) => [
                (scope.row.deletion)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.formatDeletion(scope.row.deletion)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data", "row-class-name"]),
    _createVNode(_component_DeleteReasonDialog, {
      modelValue: _ctx.showRestoreModal,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showRestoreModal) = $event)),
      variant: "restore",
      title: "Восстановить выбранные удержания?",
      "confirm-text": "Восстановить",
      "reason-label": "Причина восстановления",
      loading: _ctx.deleteLoading,
      onConfirm: _ctx.handleRestoreSelectedElements
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "Выбрано записей: " + _toDisplayString(_ctx.selectedDeleted.length), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "loading", "onConfirm"]),
    _createVNode(_component_DeleteReasonDialog, {
      modelValue: _ctx.showDeleteConfirmationModal,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.showDeleteConfirmationModal) = $event)),
      title: "Вы точно хотите удалить выбранные удержания?",
      loading: _ctx.deleteLoading,
      onConfirm: _ctx.handleDeleteSelectedElements
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, { data: _ctx.deleteConfirmationContent }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "bin",
              label: "БИН ДО"
            }),
            _createVNode(_component_el_table_column, {
              prop: "lmsId",
              label: "LMS ID"
            }),
            _createVNode(_component_el_table_column, {
              prop: "accountingMonth",
              label: "Расчетным месяц"
            }),
            _createVNode(_component_el_table_column, {
              prop: "accountingYear",
              label: "Расчетный год"
            }),
            _createVNode(_component_el_table_column, {
              prop: "retentionPrice",
              label: "Авансирование/Удержание"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue", "loading", "onConfirm"])
  ]))
}